// import request from './request';
import {
  request
} from '../main';



// 企业登录
export function iamlogin(data) {
  return request({
    url: 'verify/admin/iamLogin',
    method: 'post',
    data: data
  })
}
/**
 * @name 获取部门列表
 * @param {*} data
 * @returns
 */
export function getdepartmentlist(data) {
  return request({
    url: 'user/department/getDeparementList',
    method: 'post',
    data: data
  })
}
//add部门
export function adddepartment(data) {
  return request({
    url: 'user/department/createDeparement',
    method: 'post',
    data: data
  })
}
//del 部门
export function deldepartment(data) {
  return request({
    url: 'user/department/deparementDe',
    method: 'post',
    data: data
  })
}
//update 部门
export function upddepartment(data) {
  return request({
    url: 'user/department/deparementUp',
    method: 'post',
    data: data
  })
}

//get角色list
export function getrolelist(data) {
  return request({
    url: 'user/role/roleList',
    method: 'post',
    data: data
  })
}
//add角色
export function addrole(data) {
  return request({
    url: 'user/role/createRole',
    method: 'post',
    data: data
  })
}
//update 角色
export function updrole(data) {
  return request({
    url: 'user/role/roleUp',
    method: 'post',
    data: data
  })
}
//del角色
export function delrole(data) {
  return request({
    url: 'user/role/roleDe',
    method: 'post',
    data: data
  })
}
//获取所有部门可用的全部资源
export function getAllDepartmentResourceList(data) {
  return request({
    url: 'user/authority/getDepartmentList',
    method: 'post',
    data: data
  })
}

//给部门分配资源
export function allocationDepartment(data) {
  return request({
    url: 'user/allocationDepartment/allocationDepartment',
    method: 'post',
    data: data
  })
}
//获取角色可用资源
export function getroleuse(data) {
  return request({
    url: 'user/authority/getRoleList',
    method: 'post',
    data: data
  })
}
//获取角色已有资源
export function getrolehaveziyuan(data) {
  return request({
    url: 'user/Authority/getRoleResourceList',
    method: 'post',
    data: data
  })
}
//给角色分配资源
export function uproleziyuan(data) {
  return request({
    url: 'user/allocationDepartment/allocationRole',
    method: 'post',
    data: data
  })
}

//获取当前选中部门已有的资源

export function getDepartmentResourceList(data) {
  return request({
    url: 'user/Authority/getDepartmentResourceList',
    method: 'post',
    data: data
  })
}
//获取待审核订单
export function getrisklist(data) {
  return request({
    url: 'user/riskCenter/getWaitList',
    method: 'post',
    data: data
  })
}
//审批订单
export function shenpiorder(data) {
  return request({
    url: 'user/riskCenter/approvalStart',
    method: 'post',
    data: data
  })
}

/**
 * 获取LBD订单列表
 * @param data.page [当前页码]
 * @param data.pageSize [每页显示条数]
 * @param data.orderNo [订单号]
 * @param data.company_name [主账号名模糊搜索]
 * @param data.sub_name": "",//子账号名模糊搜索
 * @param data.lab [lab]
 * @param data.status [status]
 * @param data.state [state]
 * @param data.name [姓名模糊搜索]
 * @param data.cardid [身份证id]
 * @param data.jieguo [是否查询已处理订单]
 * @param data.type [type]：day / week / month / custom
 * @param data.starttime [开始时间]
 * @param data.endtime [结束时间]
 */
export function getLBDlist(data) {
  return request({
    url: '/user/admin/order/getlist',
    method: 'post',
    data: data
  })
}



/**
 * 新增关于资源管理的相关的请求URL
 * 含有父子资源的CURD
 */

/**
 * @name 创建父资源
 * @param {Object} data [name,type,icon]
 */
export function createParentResource(data) {
  return request({
    url: 'user/authority/createParentResource',
    method: 'post',
    data: data
  })
}

/**
 * @name 删除父资源
 * @param {Object} data [id]
 */
export function deParentResource(data) {
  return request({
    url: 'user/authority/deParentResource',
    method: 'post',
    data: data
  })
}

/**
 * @name 更新修改父资源
 * @param {Object} data [id,name,icon,type]
 */
export function upParentResource(data) {
  return request({
    url: 'user/authority/upParentResource',
    method: 'post',
    data: data
  })
}


/**
 * @name 创建子资源
 * @param {Object} data [id,name,icon,status,description,path]
 */
export function createChildResource(data) {
  return request({
    url: 'user/authority/createChildResource',
    method: 'post',
    data: data
  })
}

/**
 * @name 删除子资源
 * @param {Object} data [id]
 */
export function deChildResource(data) {
  return request({
    url: 'user/authority/deChildResource',
    method: 'post',
    data: data
  })
}

/**
 * @name 更新修改子资源
 * @param {Object} data [id,main_id,name,icon,status,description,path]
 */
export function upChildResource(data) {
  return request({
    url: 'user/authority/upChildResource',
    method: 'post',
    data: data
  })
}
/**
 * @name 获取菜单列表
 * @param {Object} 
 */
export function menulist(data) {
  return request({
    url: 'user/common/getMenuList',
    method: 'post',
    data: data
  })
}

/**
 * @name CA签发证书
 * @param {Object} data
 * @param {Object} data.orderNo [订单号]
 * @return {Object} 
 */
export function casSign(data) {
  return request({
    url: '/user/riskCenter/ca',
    method: 'post',
    data: data
  })
}

/**
 * 获取充值订单列表
 * @param {Object} data
 * @param {Object} data.page [页码]
 * @param {Object} data.pageSize [每页数量]
 * @param {Object} data.orderNo [订单号]
 * @param {Object} data.paytype [支付类型]
 * @param {Object} data.status [状态]
 * @return {Object} 
 */

export function getRechargeList(data) {
  return request({
    url: 'user/admin/recharge/getlist',
    method: 'post',
    data: data
  })
}

/**
 * 对公订单审批
 * @param {Object} data
 * @param {Object} data.orderNo [订单号]
 * @return {Object} 
 */
export function dgchongzhi(data) {
  return request({
    url: 'user/admin/recharge/dgchongzhi',
    method: 'post',
    data: data
  })
}

/**
 * 机构管理
 * 主账号管理
 * @param {Object} data
 * @param data.page [页码]
 * @param data.pageSize [每页数量]
 * @param data.name [机构名称]
 */
export function getmainlist(data) {
  return request({
    url: '/user/admin/company/getmainlist',
    method: 'post',
    data: data
  })
}
/**
 * 机构管理
 * 子账号管理
 * @param {Object} data
 * @param data.page [页码]
 * @param data.pageSize [每页数量]
 * @param data.name [机构名称]
 */
export function getiamlist(data) {
  return request({
    url: '/user/admin/company/getiamlist',
    method: 'post',
    data: data
  })
}

/**
 * 获取APIKEY列表
 * @param {Object} data
 * @param data.page [页码]
 * @param data.pageSize [每页数量]
 * @param data.name [机构名称]
 */
export function getapikeylist(data) {
  return request({
    url: '/user/admin/userkey/getlist',
    method: 'post',
    data: data
  })
}

/**
 * 生成新的APIKEY
 * @param {Object} data
 * @param data.conmpany_id [机构ID]
 */
export function setapikey(data) {
  return request({
    url: '/user/admin/userkey/setkey',
    method: 'post',
    data: data
  })
}

/**
 * 更新apikey密钥
 * @param {Object} data
 * @param data.company_id
 */
export function updateapikey(data) {
  return request({
    url: '/user/admin/userkey/updkey',
    method: 'post',
    data: data
  })
}

/**
 * 获取机构已有订阅的API列表
 * @param {Object} data
 * @param data.id [机构ID]
 */
export function getsublist(data) {
  return request({
    url: '/user/admin/subscribe/getsublist',
    method: 'post',
    data: data
  })
}

/**
 * 获取所有可订阅的API列表
 * 无参数
 */
export function getlist(data) {
  return request({
    url: '/user/admin/subscribe/getlist',
    method: 'post',
    data: data
  })
}

/**
 * 修改订阅状态
 * @param {Object} data
 * @param data.id [订阅ID]
 * @param data.state [状态]
 * @param data.price [价格]
 * */

export function upsub(data) {
  return request({
    url: '/user/admin/subscribe/upsub',
    method: 'post',
    data: data
  })
}

/**
 * 添加机构订阅
 * @param {Object} data
 * @param data.id [机构ID]
 * @param data.goods_id [APIID]
 * */
export function addsub(data) {
  return request({
    url: '/user/admin/subscribe/addsub',
    method: 'post',
    data: data
  })
}

/**
 * ip白名单列表
 * @param {Object} data
 * @param data.page [页码]
 * @param data.pageSize [每页数量]
 */
export function getiplist(data) {
  return request({
    url: '/user/admin/ip/getiplist',
    method: 'post',
    data: data
  })
}

/**
 * 添加IP白名单
 * @param {Object} data
 * @param data.company_id [机构ID]
 * @param data.ip [IP地址]
 */
export function addip(data) {
  return request({
    url: '/user/admin/ip/addip',
    method: 'post',
    data: data
  })
}

/**
 * 删除IP白名单
 * @param {Object} data
 * @param data.id [IP白名单的ID]
 */
export function delip(data) {
  return request({
    url: '/user/admin/ip/delip',
    method: 'post',
    data: data
  })
}


/**
 * 获取待审核CA订单
 * @param {Object} data
 * @param data.page [页码]
 * @param data.pageSize [每页数量]
 * @param data.orderNo [状态]
 * @param data.cardid [卡号]
 * @param data.name [卡号]
 * */
export function getcaWaitList(data) {
  return request({
    url: '/user/riskCenter/getcaWaitList',
    method: 'post',
    data: data
  })
}

/**
 * 签发CA
 * @param {Object} data
 * @param data.orderNo [CA订单ID]
 */

export function addszhca(data) {
  return request({
    url: '/user/riskCenter/addszhca',
    method: 'post',
    data: data
  })
}

/**
 * 审核CA订单
 * @param {Object} data
 * @param data.orderNo [CA订单ID]
 * @param data.state [状态]
 * @param data.state_tips [备注]
 */

export function caapprovalStart(data) {
  return request({
    url: '/user/riskCenter/caapprovalStart',
    method: 'post',
    data: data
  })
}

//数据管理

/**
 * 调用数据管理接口
 * @param data.type [type]：day / week / month / custom
 * @param data.starttime [开始时间]
 * @param data.endtime [结束时间]
 */

export function getbdcListData(data) {
  return request({
    url: '/user/admin/data/bdc',
    method: 'post',
    data: data
  })
}
